
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { convertFactSampleArrayToStepSampleArray } from '@/modules/analysis/helpers/analysisSamplesWorkflow';
import { Sample, SampleBatch } from '@/modules/analysis/models/analysisRequest';
import SampleBatchDetails from '@/modules/analysis/components/SampleBatchDetails.vue';

@Component({
  components: { SampleBatchDetails }
})
export default class BarcodeReadResultCard extends Vue {
  @Prop({ required: true })
  protected sampleBatch!: SampleBatch;
  protected sample: Sample | null = null;
  protected show = false;

  protected mounted(): void {
    this.show = true;
  }

  @Watch('sampleBatch', { deep: true, immediate: true })
  protected onSampleBatchChange(): void {
    this.sample = this.sampleBatch.samples[0];
    if (this.sample.facts) {
      this.sample.steps = convertFactSampleArrayToStepSampleArray(this.sample.facts);
    }
  }

  protected toDate(dateStr: string): Date {
    return new Date(dateStr);
  }
}
